"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsTimeOffConflict = void 0;
const ac_1 = require("@app/ac");
const records_list_1 = __importDefault(require("@app/component/modals/confirm/records-list"));
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const filtered_content_for_organization_1 = require("@app/util/filtered-content-for-organization");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const use_modal_1 = require("@app/util/modal/use-modal");
const _ui_1 = require("@ui");
const react_1 = __importStar(require("react"));
const CONTAINER_STYLE = {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
};
const DROPDOWN_CONTAINER_STYLE = { width: '50%' };
const ActionsTimeOffConflict = ({ conflictingShifts, resultTimeOffs, afterClose, }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const { closeModal } = (0, use_modal_1.useModal)();
    const radioOptions = [
        (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('timeoff_conflict_dropdown_option4', {
            label: (0, util_1.t)('TIMEOFF_CONFLICT_ACTION4'),
            value: 'unassign-shift',
        }, undefined),
        isPluginEnabled('offers')
            ? (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('timeoff_conflict_dropdown_option5', {
                label: (0, util_1.t)('TIMEOFF_CONFLICT_ACTION5'),
                value: 'offer-shift',
            }, undefined)
            : null,
        // {
        //  label: t('TIMEOFF_CONFLICT_ACTION2'),
        //  value: 'delete-timeoffs'
        // },
        (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('timeoff_conflict_dropdown_option3', {
            label: (0, util_1.t)('TIMEOFF_CONFLICT_ACTION3'),
            value: 'ignore',
        }, undefined),
        (0, filtered_content_for_organization_1.getFilteredContentForOrganization)('timeoff_conflict_dropdown_option1', {
            label: (0, util_1.t)('TIMEOFF_CONFLICT_ACTION1'),
            value: 'short-shift',
        }, undefined),
    ].filter(util_1.isValue);
    const lastSelectedType = window.localStorage.getItem('ds-selected-conflict-resolution-type');
    const [actionType, setType] = (0, react_1.useState)(lastSelectedType && radioOptions.some((ro) => ro.value === lastSelectedType)
        ? lastSelectedType
        : radioOptions[0].value);
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    const handleSave = () => {
        setIsSaving(true);
        dispatch((0, ac_1.handleTimeOffConflict)(conflictingShifts, resultTimeOffs, actionType)).then(() => {
            setIsSaving(false);
            closeModal();
            afterClose?.();
        });
    };
    const afterCloseFn = () => {
        dispatch((0, ac_1.handleTimeOffConflict)(conflictingShifts, resultTimeOffs, 'delete-timeoffs')).then(() => {
            afterClose?.();
        });
    };
    return (react_1.default.createElement(_ui_1.Modal, { afterClose: afterCloseFn, size: _ui_1.Modal.SIZES.L, noClose: true, headerContent: react_1.default.createElement(_ui_1.Text, { text: (0, util_1.t)('CONFLICTING_SHIFTS_TITLE'), type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }), footerContent: react_1.default.createElement(_ui_1.Flex, { grow: 1, justify: _ui_1.Flex.POSITION.END },
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_6, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(_ui_1.Button, { label: (0, util_1.t)('CONFIRM'), style: _ui_1.Button.STYLES.CONTAINED, onClick: handleSave, loading: isSaving, disabled: isSaving })) },
        react_1.default.createElement("div", { style: CONTAINER_STYLE },
            react_1.default.createElement(_ui_1.Alert, { text: (0, util_1.t)('SAVE_UNAV_CONFLICTS_SHIFTS_SUBTITLE'), size: _ui_1.Alert.SIZES.FULL_WIDTH, type: _ui_1.Alert.TYPES.WARNING }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16 }),
            react_1.default.createElement(records_list_1.default, { records: conflictingShifts }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16 }),
            react_1.default.createElement("div", { style: DROPDOWN_CONTAINER_STYLE },
                react_1.default.createElement(_ui_1.Dropdown, { size: 'full-width', singleSelect: true, type: 'variable', style: 'light', label: (0, util_1.t)('TIMEOFF_CONFLICTS_RESOLVE_MESSAGE'), options: radioOptions, value: radioOptions.find((opt) => opt.value === actionType), onChange: (v) => {
                        setType(v.value);
                        window.localStorage.setItem('ds-selected-conflict-resolution-type', v.value);
                    } })))));
};
exports.ActionsTimeOffConflict = ActionsTimeOffConflict;
